<template>
    <div class="modal fade" id="successfull-modal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-md-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title w-100">
                        <h2 class="mt-0 title--1" v-html="message"/>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text my-3" v-html="second_message"/>
                    </div>
                </div>
                <div class="modal__buttons mt-0 text-center text-md-right">
                    <button type="button" class="modal__buttons__item" @click="event_emition()">Ok</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'SuccessfullModal',

    props: [
        'message',
        'second_message',
    ],

    methods: {
        event_emition()
        {
            this.$emit('ConfirmSuccess', true)
        }
    },

    mounted(){

    }
}
</script>